
import { Vue, Component } from "vue-property-decorator";
import { capitalizeFirst } from "@/utils";
import { IInstructor, IUser } from "@/schemas/IUser";
import { ISequence } from "@/schemas/ISequence";
import SequenceForm from "@/components/admin/entityForm/SequenceForm.vue";
import TipGroupForm from "@/components/admin/entityForm/TipGroupForm.vue";
import ActivityForm from "@/components/admin/entityForm/ActivityForm.vue";
import { mapGetters, mapState } from "vuex";

@Component({
  computed: {
    ...mapState("user", ["users"]),
    ...mapGetters("user", ["isAdministrator"]),
  },
})
export default class registerAdminPage extends Vue {
  data(): any {
    return {
      headers: [
        {
          text: "Module",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "pdf", value: "pdf_name" },
        { text: "Consulté", value: "count_vue" },
        { text: "Téléchargé", value: "count_Download" },
      ],
      editedIndex: -1,
      moduleList: [],
    };
  }

  created() {
    this.$store.dispatch("moduleConsultationGet", {
      next: (response) => {
        console.log(response);
        response.sort(this.compare);
        this.moduleList = response;
      },
    });
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }
}
//
//
